"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _async = _interopRequireDefault(require("react-select/async"));
var _asyncCreatable = _interopRequireDefault(require("react-select/async-creatable"));
var _creatable = _interopRequireDefault(require("react-select/creatable"));
var _styledSystem = require("styled-system");
var _ = require("..");
var _loadingIndicator = require("../LoadingIndicator/loading-indicator.style");
var _constant = require("../../styles/constant");
var _theme = _interopRequireDefault(require("./../../styles/theme"));
var _FormElements = require("../../styles/FormElements");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
const fit = (0, _styledSystem.variant)({
  prop: 'fit',
  variants: {
    small: {
      minHeight: (0, _constant.get)('space.32'),
      fontSize: (0, _constant.get)('fontSizes.s'),
      borderRadius: (0, _constant.get)('borderRadius.s'),
      padding: "".concat((0, _constant.get)('space.0'), " ").concat((0, _constant.get)('space.8'))
    },
    medium: {
      minHeight: (0, _constant.get)('space.40'),
      fontSize: (0, _constant.get)('fontSizes.m'),
      borderRadius: (0, _constant.get)('borderRadius.m'),
      padding: "".concat((0, _constant.get)('space.0'), " ").concat((0, _constant.get)('space.12'))
    },
    large: {
      minHeight: (0, _constant.get)('space.48'),
      fontSize: (0, _constant.get)('fontSizes.l'),
      borderRadius: (0, _constant.get)('borderRadius.m'),
      padding: "".concat((0, _constant.get)('space.0'), " ").concat((0, _constant.get)('space.16'))
    }
  }
});
const selectVariant = (0, _styledSystem.variant)({
  prop: 'variant',
  variants: {
    "default": {
      border: '1px solid'
    },
    vanity: {
      borderBottom: '2px solid',
      borderTop: (0, _constant.get)('space.0'),
      borderLeft: (0, _constant.get)('space.0'),
      borderRight: (0, _constant.get)('space.0'),
      borderRadius: (0, _constant.get)('space.0'),
      paddingLeft: (0, _constant.get)('space.0'),
      paddingRight: (0, _constant.get)('space.0')
    }
  }
});
const variants = {
  fit,
  selectVariant,
  inputErrorFocusVariant: _FormElements.inputErrorFocusVariant,
  inputFocusVariant: _FormElements.inputFocusVariant
};
const commonStyle = (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  .MultiSelect__control {\n    ", "\n    ", "\n    ", "\n    border-color: ", ";\n    .MultiSelect__indicator.MultiSelect__dropdown-indicator {\n      padding: 0;\n      margin-right: ", ";\n    }\n  }\n\n  .MultiSelect__control--is-focused {\n    box-shadow: ", ";\n\n    .MultiSelect__single-value {\n      color: ", ";\n    }\n  }\n"])), variants.fit, variants.selectVariant, props => props.error ? variants.inputErrorFocusVariant : variants.inputFocusVariant, props => props.error ? (0, _constant.get)('colors.feedback.danger.normal') : (0, _constant.get)('colors.functional.grey.400'), props => props.fit === 'small' ? (0, _constant.get)('space.6') : props.fit === 'medium' ? (0, _constant.get)('space.10') : (0, _constant.get)('space.12'), props => props.variant === 'vanity' ? (0, _constant.get)('boxShadows.type.vanity.default') : (0, _constant.get)('boxShadows.type.basic.default'), (0, _constant.get)('colors.functional.grey.600'));
const Wrapper = (0, _styledComponents["default"])(_.Box)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  width: ", ";\n  .MultiSelect__indicators button {\n    padding: 0;\n    min-height: auto;\n  }\n  i {\n    color: ", ";\n  }\n"])), props => props.width ? "".concat(props.width, "%") : '100%', (0, _constant.get)('colors.functional.grey.600'));
const RefWrapper = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])([""])));
const LoadingIndicator = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  right: ", ";\n  top: ", ";\n  & svg {\n    animation: ", ";\n    height: ", ";\n    width: ", ";\n  }\n  & .spinner {\n    stroke-width: 12.5;\n    stroke: ", ";\n  }\n  & .track {\n    stroke-width: 12.5;\n    stroke: ", ";\n  }\n"])), (0, _constant.get)('space.30'), (0, _constant.get)('space.0'), _loadingIndicator.spinnerAnimationStyled, props => props.fit === 'small' ? (0, _constant.get)('space.16') : (0, _constant.get)('space.24'), props => props.fit === 'small' ? (0, _constant.get)('space.16') : (0, _constant.get)('space.24'), (0, _constant.get)('colors.primary.blue.300'), (0, _constant.get)('colors.functional.grey.200'));
const CreatableReactSelect = (0, _styledComponents["default"])(_creatable["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n"])), commonStyle);
const StyledSelect = (0, _styledComponents["default"])(_reactSelect["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n"])), commonStyle);
const AsyncReactSelect = (0, _styledComponents["default"])(_async["default"])(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n"])), commonStyle);
const AsyncCreatableReactSelect = (0, _styledComponents["default"])(_asyncCreatable["default"])(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n"])), commonStyle);
const multiValue = provided => {
  return (0, _extends2["default"])((0, _extends2["default"])({}, provided), {
    borderRadius: _theme["default"].borderRadius.xl
  });
};
const multiValueRemove = provided => {
  return (0, _extends2["default"])((0, _extends2["default"])({}, provided), {
    '&:hover': {
      backgroundColor: 'initial',
      color: 'initial'
    }
  });
};
const menu = provided => {
  return (0, _extends2["default"])((0, _extends2["default"])({}, provided), {
    wordWrap: 'break-word'
  });
};
const CustomStyles = {
  MultiValue: multiValue,
  MultiValueRemove: multiValueRemove,
  Menu: menu
};
const Components = exports.Components = {
  AsyncReactSelect,
  AsyncCreatableReactSelect,
  Wrapper,
  RefWrapper,
  CreatableReactSelect,
  StyledSelect,
  LoadingIndicator,
  CustomStyles
};